import React from 'react';
import { MapPin, Gift, ShoppingBag, ChevronRight, Calendar } from 'lucide-react';
import { Store, UserProfile } from '../../types';
import { StoreCard } from '../StoreCard';
import { STORES, MOCK_GIFTS } from '../../data/mockData';
import { GiftCard } from '../GiftCard';
interface HomeScreenProps {
  user: UserProfile;
  onNavigate: (screen: any) => void;
  onStoreClick: (store: Store) => void;
}
export function HomeScreen({
  user,
  onNavigate,
  onStoreClick
}: HomeScreenProps) {
  const nearbyStores = STORES.slice(0, 4);
  const featuredStore = STORES[0];
  // Map stores to reward cards
  const rewardStores = [{
    store: STORES[0],
    discount: '19% Off',
    reward: 'Free Coffee on Your Next Visit',
    lastVisit: 'May 2'
  }, {
    store: STORES[1],
    discount: '15% Off',
    reward: 'Free Miso Soup on Your Next Visit',
    lastVisit: 'May 5'
  }, {
    store: STORES[2],
    discount: '20% Off',
    reward: 'Free Salad Upgrade on Your Next Visit',
    lastVisit: 'May 8'
  }];
  return <div className="pb-24 min-h-screen bg-[#FFFF66] relative overflow-hidden" data-id="element-907">
      {/* Content Layer */}
      <div className="relative z-10" data-id="element-908">
        {/* Header Greeting - No Container */}
        <div className="px-4 pt-6 pb-4" data-id="element-909">
          <div className="flex items-start justify-between" data-id="element-910">
            <div data-id="element-911">
              <h1 className="text-3xl font-bold text-black mb-2" data-id="element-912">Hi Arjun,</h1>
              <p className="text-gray-700 text-lg" data-id="element-913">shop local like a hero!</p>
            </div>
            <img src={user.avatar} alt="Profile" className="w-16 h-16 rounded-full border-4 border-white/50 object-cover flex-shrink-0 shadow-sm transition-transform duration-200 hover:scale-110 cursor-pointer" data-id="element-914" />
          </div>
        </div>

        {/* Action Cards */}
        <div className="px-4 space-y-3 mb-8" data-id="element-915">
          <button onClick={() => onNavigate('gifting')} className="w-full rounded-3xl p-5 text-left shadow-lg transform transition-all duration-200 hover:scale-[1.01] active:scale-[0.99]" style={{
          background: '#FD3DB5'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#E5359F';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#FD3DB5';
        }} data-id="element-916">
            <div className="flex items-start gap-4" data-id="element-917">
              <div className="w-12 h-12 bg-black rounded-2xl flex items-center justify-center flex-shrink-0" data-id="element-918">
                <Gift size={24} className="text-[#FFFF66]" data-id="element-919" />
              </div>
              <div data-id="element-920">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-921">
                  Send a Gift
                </h3>
                <p className="text-white/80 text-sm" data-id="element-922">
                  Gift store credit to friends
                </p>
              </div>
            </div>
          </button>

          <button onClick={() => onNavigate('explore')} className="w-full rounded-3xl p-5 text-left shadow-lg transform transition-all duration-200 hover:scale-[1.01] active:scale-[0.99]" style={{
          background: '#CCFF00'
        }} onMouseEnter={e => {
          e.currentTarget.style.background = '#B8E600';
        }} onMouseLeave={e => {
          e.currentTarget.style.background = '#CCFF00';
        }} data-id="element-923">
            <div className="flex items-start gap-4" data-id="element-924">
              <div className="w-12 h-12 bg-black rounded-2xl flex items-center justify-center flex-shrink-0" data-id="element-925">
                <MapPin size={24} className="text-[#FFFF66]" data-id="element-926" />
              </div>
              <div data-id="element-927">
                <h3 className="text-xl font-bold text-black mb-1" data-id="element-928">
                  Find Nearby Stores
                </h3>
                <p className="text-black/70 text-sm" data-id="element-929">
                  Discover local merchants with rewards
                </p>
              </div>
            </div>
          </button>
        </div>

        {/* Your Rewards Section */}
        <div className="px-4 mb-8" data-id="element-930">
          {/* Section Header with Swipe Indicator */}
          <div className="flex items-center justify-between mb-4" data-id="element-931">
            <h2 className="text-2xl font-bold text-black" data-id="element-932">Your Rewards</h2>
            <div className="flex items-center text-black text-sm gap-2" data-id="element-933">
              <span data-id="element-934">Swipe</span>
              <ChevronRight size={20} data-id="element-935" />
            </div>
          </div>

          {/* Horizontal Scrollable Container */}
          <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory -mx-4 px-4" data-id="element-936">
            {rewardStores.map((rewardData, index) => <div key={rewardData.store.id} className="flex-shrink-0 w-[85%] snap-start" data-id="element-937">
                <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-5 shadow-lg" data-id="element-938">
                  {/* Store Header */}
                  <div className="flex items-start justify-between mb-3" data-id="element-939">
                    <h3 className="text-xl font-bold text-black" data-id="element-940">
                      {rewardData.store.name}
                    </h3>
                    <span className="bg-[#FFFC00] text-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-941">
                      {rewardData.discount}
                    </span>
                  </div>

                  {/* Last Visit */}
                  <div className="flex items-center gap-2 text-gray-600 text-sm mb-4" data-id="element-942">
                    <Calendar size={14} data-id="element-943" />
                    <span data-id="element-944">Last visit: {rewardData.lastVisit}</span>
                  </div>

                  {/* Reward Box */}
                  <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-2xl p-4 mb-4 border border-yellow-200" data-id="element-945">
                    <p className="text-black font-semibold text-base" data-id="element-946">
                      {rewardData.reward}
                    </p>
                  </div>

                  {/* Redeem Button */}
                  <button onClick={() => onStoreClick(rewardData.store)} className="w-full bg-gradient-to-br from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-3 rounded-2xl transition-all active:scale-[0.98]" data-id="element-947">
                    Redeem on Next Visit
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        {/* Nearby Favorites */}
        <div className="px-4 mb-8" data-id="element-948">
          <div className="flex justify-between items-center mb-4" data-id="element-949">
            <h2 className="text-xl font-bold text-black" data-id="element-950">Nearby Favorites</h2>
            <button onClick={() => onNavigate('explore')} className="text-sm text-black font-semibold flex items-center" data-id="element-951">
              See All <ChevronRight size={16} data-id="element-952" />
            </button>
          </div>
          <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 scrollbar-hide" data-id="element-953">
            {nearbyStores.map(store => <StoreCard key={store.id} store={store} variant="compact" onClick={() => onStoreClick(store)} data-id="element-954" />)}
          </div>
        </div>
      </div>
    </div>;
}